<template>
  <v-container fluid>
    <create-shop-drawer
      :dialog="drawer"
      @close="drawer = false"
      @save="onShopCreated"
    ></create-shop-drawer>

    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/shops' }"
        >ร้านค้าทั้งหมด</el-breadcrumb-item
      >
    </el-breadcrumb>

    <el-card class="mt-5">
      <div slot="header" class="clearfix">
        <div class="px-1 pt-2">
          <el-checkbox-group
            v-model="statusFiltered"
            @change="onStatusFilteredChanged()"
          >
            <el-checkbox
              v-for="item in shopStatusList"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="isLoading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :mobile-breakpoint="`10`"
        @page-count="pageCount = $event"
        hide-default-footer
        class="elevation-0"
      >
        <template v-slot:item.ref_no="{ item }">
          <div>
            <span class="grey--text">{{ item.ref_no }}-</span>
            {{ item.shop_id | numFormat("00000") }}
            <div>
              <div v-if="item.status == 'draft'" class="grey badge-status">
                ยังไม่สมบูรณ์
              </div>
              <div v-if="item.status == 'inactive'" class="red badge-status">
                เลิกกิจการ
              </div>
              <div
                v-if="item.status == 'temp_close'"
                class="orange badge-status"
              >
                ปิดชั่วคราว
              </div>
              <div v-if="item.status == 'published'" class="green badge-status">
                เปิดบริการอยู่
              </div>
            </div>
          </div>
        </template>

        <template v-slot:item.status="{ item }">
          <div style="width:110px;" class="my-2">
            <el-select
              v-model="item.status"
              placeholder="Select"
              :size="`mini`"
              @change="onUpdateStatus(item)"
            >
              <el-option
                v-for="item in shopStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <div style="position:relative; height:80px;" class="pt-5">
            <div
              class="pic"
              v-bind:style="{
                'background-image': 'url(' + item.logo_url + ')',
              }"
            ></div>
            <div style="padding-left:60px;">
              <div style="width:220px;">
                <div class="line-1-elipsis">
                  <strong>{{ item.name }}</strong>
                </div>
                <div class="grey--text line-1-elipsis">{{ item.excerpt }}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:item.rank="{ item }">
          <div style="width:100px;" class="my-2">
            <el-select
              v-model="item.rank"
              placeholder="Select"
              :size="`mini`"
              @change="onUpdateStatus(item)"
            >
              <el-option
                v-for="item in rankList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <div style="width:120px;">
            <el-button
              type="text"
              size="small"
              class="mr-2"
              @click="openItem(item)"
              >ดูรายละเอียด</el-button
            >
            <el-button
              class="grey--text darken-2"
              type="text"
              size="small"
              @click="openLink(item)"
            >
              <i class="fas fa-link"></i> ลิงก์
            </el-button>
          </div>
        </template>
      </v-data-table>
    </el-card>

    <div
      style="position:fixed; bottom:10px; right:10px; z-index:9; width:100%;"
    >
      <v-pagination
        circle
        v-model="page"
        :total-visible="5"
        :length="pageCount"
      ></v-pagination>
    </div>

    <link-dialog
      :links="links"
      :showDialog="linkDialog"
      @close="onLinkDialogClosed"
    ></link-dialog>
  </v-container>
</template>
<script>
import Service from "../../services";

import CreateShopDrawer from "../../components/CreateShopDrawer";
import LinkDialog from "../../components/LinkDialog";

import { mapState } from "vuex";

export default {
  components: {
    CreateShopDrawer,
    LinkDialog,
  },
  computed: {
    statusFiltered: {
      get() {
        return this.$store.state.Util.shopStatusFiltered;
      },
      set(value) {
        this.$store.dispatch("Util/setShopStatusFiltered", value);
      },
    },
  },
  data() {
    return {
      mode: "admin",
      isLoading: true,
      list: [],
      results: [],
      total: 0,
      page: 1,
      itemsPerPage: 25,
      pageCount: 0,
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "ref_no",
        },
        { text: "", value: "action", sortable: false },
        { text: "สถานะ", value: "status", sortable: false },
        { text: "ชื่อร้าน", value: "name", sortable: false },
        { text: "การจัดลำดับ", value: "rank", sortable: false },
      ],
      statusOrdering: ["temp_close", "published", "draft", "inactive"],
      shopStatusList: [
        { label: "ปิดชั่วคราว", value: "temp_close" },
        { label: "เปิดบริการอยู่", value: "published" },
        { label: "ยังไม่สมบูรณ์", value: "draft" },
        { label: "เลิกกิจการ", value: "inactive" },
      ],
      rankList: [
        { label: "แสดงผลก่อน", value: 10 },
        { label: "แสดงผลปกติ", value: 9999 },
      ],
      drawer: false,
      permission: null,
      canCreate: false,
      links: null,
      linkDialog: false,
    };
  },
  created() {
    this.loadList();

    Service.User.permission().then((resp) => {
      this.permission = resp.data;
      if (
        this.permission.user.role_id == "super_admin" ||
        this.permission.enterprises[0].ent_type == "platform"
      ) {
        this.canCreate = true;
      }
      if (this.permission.user.role_id == "enterprise_manager") {
        this.mode = "enterprise_manager";
      }
    });
  },
  methods: {
    loadList() {
      Service.Shop.gets().then((res) => {
        if (res.success) {
          this.list = res.data;
          this.total = this.list.length;
          this.list.sort(
            (a, b) =>
              this.statusOrdering.indexOf(a.status) -
              this.statusOrdering.indexOf(b.status)
          );
          this.onStatusFilteredChanged();
          //this.results = this.list;
        }
        this.isLoading = false;
      });
    },
    openItem(item) {
      this.$router.push("shop/" + item.ref_no + "/view");
    },
    openLink(item) {
      Service.Shop.getLink(item.ref_no).then((res) => {
        this.links = res.data;
        this.linkDialog = true;
      });
    },
    onLinkDialogClosed() {
      this.links = null;
      this.linkDialog = false;
    },
    onShopCreated() {
      this.loadList();
      this.drawer = false;
    },
    onUpdateStatus(item) {
      let data = {
        ref_no: item.ref_no,
        shop_status: item.status,
        rank: item.rank,
      };
      Service.Shop.update(data).then((res) => {});
    },
    onStatusFilteredChanged() {
      this.results = this.list.filter((x) =>
        this.statusFiltered.includes(x.status)
      );
    },
  },
};
</script>
<style scoped>
.v-chip .v-chip__content {
  text-align: center;
}

.shop-cover {
  width: 60px;
  height: 60px;
  margin: 15px 8px;
  background-size: cover;
  background-position: center;
  float: left;
}

.pic {
  width: 50px;
  height: 50px;
  margin: auto;
  background-size: cover;
  position: absolute;
  top: 20px;
  left: 0;
}
</style>
